import { getUriAndCacheResponse } from "@/_services/cache"
import { addOops } from "@/_services/notification"
import { fullStackScripts, isGreaterThanOrEqual } from "basikon-common-utils"

const cache = {}

export async function getTaxes() {
  let taxes = []
  try {
    taxes = await getUriAndCacheResponse("/api/core/taxes")
  } catch (error) {
    addOops(error)
  }
  return taxes
}

export async function getIndexes() {
  let indexes = []
  try {
    indexes = await getUriAndCacheResponse("/api/core/indexes")
  } catch (error) {
    addOops(error)
  }
  return indexes
}

export async function getCurrencies() {
  let currencies = []
  try {
    currencies = await getUriAndCacheResponse("/api/core/currencies")
    cache.currenciesMap = Object.fromEntries(currencies.map(currency => [currency.code, currency]))
  } catch (error) {
    addOops(error)
  }
  return currencies
}

export function getCachedCurrenciesMap() {
  return cache.currenciesMap || {}
}

export async function getFunds() {
  let funds = []
  try {
    funds = await getUriAndCacheResponse("/api/financing/funds")
  } catch (error) {
    addOops(error)
  }
  return funds
}

export async function getCalendars() {
  let calendars = []
  try {
    calendars = await getUriAndCacheResponse(`/api/script/runs/${fullStackScripts.calendars}`)
  } catch (error) {
    addOops(error)
  }
  return calendars
}

export function getBankAccountLabel(bankAccount) {
  if (!bankAccount) return bankAccount
  return `${bankAccount.bankIban} ${bankAccount.name && bankAccount.name !== bankAccount.bankIban ? `(${bankAccount.name})` : ""}`
}

export function toBankAccountOptions(bankAccounts) {
  return (bankAccounts || []).map(bankAccount => ({
    value: bankAccount.bankIban,
    label: getBankAccountLabel(bankAccount),
    data: bankAccount,
  }))
}

export async function getTaxRate(taxCode) {
  const taxes = await getTaxes()
  let rate = taxes?.find(tax => tax.code === taxCode)?.value
  // no rate means no tax
  if (!rate) rate = 0
  return rate
}

export function computeCurrency(amount, currency) {
  const currencyValue = getCachedCurrenciesMap()?.[currency]?.value || 0
  if (isGreaterThanOrEqual(amount, 0)) return amount * currencyValue
}
